setLocalStorage();
stickyHeader();
mobileMenu();
accordion();
scrollToId();
sendForm();
phoneMask();

/**
 * Set Local Storage
 */
function setLocalStorage() {
	if (!localStorage.getItem('hash')) {
		localStorage.setItem('hash', 0)
	}
}

/**
 * Inputmask
 * @param {*} elem 
 */
function phoneMask() {
	let inputs = document.querySelectorAll('input[type=tel');
	if(inputs) {
		inputs.forEach((input) => {
			Inputmask({
				'mask': '7|8(999)9999999'
			}).mask(input);
		})
	}
}

/**
 * Get Siblings Elements
 */
var getSiblings = function (elem) {
	return Array.prototype.filter.call(elem.parentNode.children, function (sibling) {
		return sibling !== elem;
	});
};

// STICKY HEADER
function stickyHeader() {
	const header = document.querySelector("#masthead");
	const scrollUp = "sticky";
	const scrollDown = "sticky-up";
	let lastScroll = 0;

	window.addEventListener("scroll", () => {
		const currentScroll = window.pageYOffset;
		if (currentScroll <= 200) {
			header.classList.remove(scrollUp);
			header.classList.remove(scrollDown);
			return;
		}

		if (currentScroll > lastScroll && !header.classList.contains(scrollDown)) {
			// down
			header.classList.remove(scrollUp);
			header.classList.add(scrollDown);
		} else if (currentScroll < lastScroll && header.classList.contains(scrollDown)) {
			// up
			header.classList.remove(scrollDown);
			header.classList.add(scrollUp);
		}
		lastScroll = currentScroll;
	});
}

// MOBILE MENU
function mobileMenu() {
	let el = document.querySelectorAll('.menu-toggle');
	for (var i = 0; i < el.length; i++) {
		el[i].addEventListener('click', function () {
			toggleMenu()
			document.body.classList.toggle('open');			
		});
	}
}

function toggleMenu() {
	document.querySelector('.main-navigation').classList.toggle('active');
	document.querySelector('.menu-bg').classList.toggle('active');
}

function toggleModal(btn) {
	document.querySelector('.main-navigation').classList.toggle('active');
	btn.classList.toggle('active');
	document.querySelector('.menu-bg').style.display = 'none';
	// Disable vertical scroll for body
	document.body.classList.toggle('open');
}

// GET COOKIE
function getCookie(name) {
	let matches = document.cookie.match(new RegExp(
		"(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
	));
	return matches ? decodeURIComponent(matches[1]) : undefined;
}

/**
 * Scroll to Id
 */
function scrollToId() {
	let link = document.querySelectorAll('.menu-item a[href*="#"]');
	link.forEach(function (item) {
		item.addEventListener('click', function (evt) {
			localStorage.setItem('hash', 0);
			let goal = item.hash.replace('#', '');
			if (window.location.pathname === '/') {
				evt.preventDefault();
				let el = document.getElementById(goal);
				if (document.querySelector('.main-navigation').classList.contains('active')) {
					toggleModal(document.querySelector('.btn-menu'));
				}
				scroll(el);
				//clickMobileMenu();
			} else {
				evt.preventDefault();
				let hash = item.hash,
					link = window.location.origin + '/' + item.hash;
				localStorage.setItem('hash', hash);
				window.location.replace(window.location.origin);
				//clickMobileMenu();
			}
		});
	});
}
/**
 * Scroll if localStorage('hash') isn't null
 */
function locStor() {
	if (localStorage.getItem('hash') != 0) {
		let el = document.getElementById(localStorage.getItem('hash').replace('#', ''));
		if (el) {
			scroll(el);
			localStorage.setItem('hash', '');
		}
	}
}

/**
 * Scroll function
 * @param {*} offsetPosition 
 * @param {*} headerOffset 
 */
function scroll(el) {
	let headerOffset = document.getElementById('masthead').offsetHeight,
		elementPosition = el.offsetTop;
	//offsetPosition = elementPosition - headerOffset;

	if (elementPosition >= 0) {
		window.scrollTo({
			top: elementPosition - 60,
			behavior: 'smooth'
		});
	} else {
		window.scrollTo({
			top: headerOffset,
			behavior: 'smooth'
		});
	}
}

// MODAL WINDOW
const modalTriggerOpen = () => {
	let trigger = document.getElementsByClassName('modal-trigger');
	if (trigger) {
		Array.prototype.filter.call(trigger, (trigger) => {
			trigger.addEventListener('click', (e) => {
				e.preventDefault()
				let target = document.getElementById(trigger.dataset.target)
				modalOpen(target)
				modalTriggerClose(target)
			}, true)
		})
	}
}

const modalTriggerClose = (modal) => {
	let close = document.getElementsByClassName('modal-toggle');
	Array.prototype.filter.call(close, (close) => {
		close.addEventListener('click', () => modalClose(modal))
	})
}

const modalOpen = (target) => {
	target.classList.add('show')
	document.body.classList.add('open')
}
const modalClose = (target) => {
	target.classList.remove('show')
	document.body.classList.remove('open')
	if(document.querySelector('.main-navigation').classList.contains('active')) {
		toggleMenu()
	}
	
}

modalTriggerOpen();


/**
 * ACCORDION
 */
function accordion() {
	let tab = document.getElementsByClassName('acc-item');
	if (tab.length != 0) {
		tab[0].classList.add('active');
		Array.prototype.filter.call(tab, (tab) => {
			let tabHead = tab.querySelector('.acc-head');
			tabHead.addEventListener('click', () => {
				tab.classList.toggle('active');
				getSiblings(tab).forEach(elem => {
					elem.classList.remove('active');
				});
			});
		});
	}
}

/**
 * TABS
 * @param {tabs, heads} 
 */
class Tabs {
	constructor(heads, tabs) {
		this.heads = heads;
		this.tabs = tabs;
		if (this.heads) {
			this.heads.addEventListener('click', event => {
				if (event.target.closest('.tab-head') && !event.target.classList.contains('active')) {
					const index = event.target.closest('.tab-head').dataset.tab;
					this.openTab(index);
				}
			});
		}
	}

	openTab(index) {
		this.heads.querySelector('.active').classList.remove('active');
		this.heads.querySelector(`[data-tab="${index}"`).classList.add('active');
		this.tabs.querySelector('.active').classList.remove('active');
		this.tabs.querySelector(`[data-tab="${index}"`).classList.add('active');
	}
}

document.addEventListener('DOMContentLoaded', () => {
	const heads = document.querySelector('.tabs-head');
	const tabs = document.querySelector('.tabs-body');
	const tabList = new Tabs(heads, tabs);
});

// VIDEO AUTOPLAY
function autoplayVideo(section) {
	// Variables
	var section = document.querySelectorAll('.has-video');
	// for each choosen element apply the effect
	section.forEach(function (screen, index) {
		// Inner element
		var offset = document.querySelector('header').offsetHeight,
			video = screen.querySelector('video'),
			vHeight = video.offsetHeight,
			poster = video.nextElementSibling;

		// When the user scrolls and animation block is in viewport
		window.addEventListener('scroll', function () {
			// The distance to scroll inside the horizontal element
			// = Section height - Window height 
			var distance = screen.offsetHeight + (offset * 2) + vHeight - window.innerHeight,
				// Scroll position inside the element
				// = Scroll position - Section offset to top document
				position = window.scrollY - (screen.getBoundingClientRect().top + pageYOffset),
				// The progress between  0 & 1 is the scroll position
				//  inside the element divided by the distance scroll
				progress = (position / distance);
			// If Progeress is between 0 & 1 - section is in viewport and we are fixing section
			if (progress > 0 && progress < 1) {
				// Play Video
				video.play();
				if (poster) {
					poster.style.visibility = 'hidden';
				}
			} else {
				// Pause Video	
				video.pause();
				if (poster) {
					poster.style.visibility = 'visible';
				}
			}
		});
	});
}

/**
 * COUNTDOWN TIMER
 */
const countdownTimer = () => {
	const timer = document.getElementsByClassName('timer')
	if (timer) {
		Array.prototype.filter.call(timer, (timer) => {
			let dateTo = new Date(`${timer.dataset.expire} GMT+03:00`).getTime();
			if (dateTo > new Date().getTime()) {
				const interval = setInterval(() => counter(timer, dateTo), 60000)
				counter(timer, dateTo)
			}
		})
	}
}

const counter = (el, dateTo) => {
	let now = new Date().getTime(),
		distance = dateTo - now,
		base = 1000 * 60 * 60,
		days = Math.floor(distance / (base * 24)),
		hours = Math.floor((distance % (base * 24)) / (base)),
		minutes = Math.floor((distance % (base)) / (1000 * 60));

	el.querySelector('.counter-day').textContent = days
	el.querySelector('.counter-hour').textContent = hours
	el.querySelector('.counter-minute').textContent = minutes
}
countdownTimer()

/**
 * ANIMATED NUMBER
 */
// How long you want the animation to take, in ms
const animationDuration = 2000;
// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
const frameDuration = 1000 / 60;
// Use that to calculate how many frames we need to complete the animation
const totalFrames = Math.round(animationDuration / frameDuration);
// An ease-out function that slows the count as it progresses
const easeOutQuad = t => t * (2 - t);

// The animation function, which takes an Element
const animateCountUp = el => {
	let frame = 0;
	const countTo = parseFloat(el.innerHTML, 10);
	// Start the animation running 60 times per second
	const counter = setInterval(() => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad(frame / totalFrames);
		// Use the progress value to calculate the current count
		const currentCount = Math.round(countTo * progress);

		// If the current count has changed, update the element
		if (parseInt(el.innerHTML, 10) !== currentCount) {
			el.innerHTML = currentCount;
		}

		// If we’ve reached our last frame, stop the animation
		if (frame === totalFrames) {
			clearInterval(counter);
		}
	}, frameDuration);
};

// Run the animation on all elements with a class of ‘countup’
const runAnimations = () => {
	const countupEls = document.querySelectorAll('.animated-num');
	countupEls.forEach(animateCountUp);
};
//runAnimations()

/**
 * RANGE SLIDER
 */
const customSlider = () => {
	let wrapp = document.querySelectorAll('.steps-wrapper')
	if (wrapp) {
		wrapp.forEach(wrapp => {
			let range = wrapp.querySelector('.range'),
				left = wrapp.querySelector('.arr-left'),
				right = wrapp.querySelector('.arr-right')
			panel = wrapp.querySelector('.steps-box'),
				total = panel.scrollWidth - panel.offsetWidth;

			range.addEventListener('input', () => {
				let percentage = total * (range.value / 100)
				changeRange(percentage)
			})

			const changeRange = (percentage) => {
				panel.scrollLeft = percentage
			}

			left.addEventListener('click', () => {
				range.value = parseInt(range.value) - 10
				changeRange(total * (range.value / 100))
			})
			right.addEventListener('click', () => {
				range.value = parseInt(range.value) + 10
				changeRange(total * (range.value / 100))
			})
		})
	}
}
customSlider()

function sendForm() {
  document.addEventListener('wpcf7mailsent', (event) => {
		let form = document.getElementById(event.detail.id),
		modal = form.closest('.modal-wrapper'),
		heading_def = modal.querySelectorAll('.def'),
		heading_send = modal.querySelectorAll('.send'),
		formInner = form.querySelector('.form-inner'),
		output = form.querySelector('.wpcf7-response-output');


		formInner.style.display = "none";
		heading_def.forEach((def) => def.style.display = 'none')
		heading_send.forEach((send) => send.style.display = 'block')
    setTimeout(() => {
			modalClose(modal)
			output.style.display = "none"			
			formInner.style.display = "block"
			heading_def.forEach((def) => def.style.display = 'none')
			heading_send.forEach((send) => send.style.display = 'block')
    }, 12000);
  }, false);
}

/**
 * DEFAULT SCHOOL NUMBER ON FORM
 */
const inputSchool = () =>{
	let inputs = document.getElementsByName('school')
	Array.prototype.filter.call((inputs), input => {
		if(getCookie('school')) {
			input.value = getCookie('school').replace('+', ' ')
		}
	})
}
inputSchool()
const schoolBlock = document.getElementsByClassName('school-list-wrapper');
//const schoolList = document.getElementById('schoolList');
if (typeof schoolBlock !== 'undefined') {

  // showSchool();
  // closeListener();

  // OPEN SELECT
  const openList = () => {
    Array.prototype.filter.call(schoolBlock, (list) => {
      let btn = list.querySelector('.choose-number'),
        select = list.querySelector('.school-list');
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.preventDefault()
          select.classList.toggle('show')
        })
      }
    })
  }

  // CHOOSE SCHOOL
  const chooseSchool = () => {
    Array.prototype.filter.call(schoolBlock, (list) => {
      let schoolNum = list.querySelectorAll('.school-link'),
        select = list.querySelector('.school-list'),
        currSchool = list.querySelector('.number');
      schoolNum.forEach(school => {
        school.addEventListener('click', (e) => {
          e.preventDefault()
          let number = school.dataset.school;
          document.cookie = `school=${number}; max-age=2592000‬; path=/;`
          currSchool.textContent = number
          closeSchoolList(select)
        })
      })
    })
  }

  // CLOSE LIST
  const closeSchoolList = (list) => {
    list.classList.toggle('show')
  }

  /**
   * Call Functions
   */
  openList();
  chooseSchool();
}